<template>
  <v-container>
    <v-tabs
      v-model="tab"
      slider-color="secondary"
      color="primary"
      background-color="transparent"
      active-class="secondary"
    >
      <v-tab>{{$t('News.List.header')}}</v-tab>
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="newsList"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-dialog v-model="showEditor" max-width="700px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('News.Button.add')}}</v-btn>
                </template>
                <NewsEditor
                  v-if="showEditor"
                  :defaultNews="editedIndex >= 0 ? newsList[editedIndex] : null"
                  :formTitle="editedIndex >= 0 ? 'Modification' : 'Création'"
                  @save="save"
                  @cancel="close"
                />
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item="props">
            <tr>
              <td>
                <v-icon v-if="props.item.type === 'image'">image</v-icon>
                <v-icon v-else-if="props.item.type === 'image-cover'">photo_album</v-icon>
              </td>
              <td class="py-1">
                <v-img :src="getNewsImgPath(props.item.imageName)" height="100px" aspect-ratio="3/2" contain></v-img>
              </td>
              <td>{{ props.item.title }}</td>
              <td>
                <v-chip color="primary" text-color="white" v-if="props.item.author">
                  <v-avatar>
                    <v-icon>account_circle</v-icon>
                  </v-avatar>
                  {{ props.item.author }}
                </v-chip>
              </td>
              <td>{{ formatDate(props.item.updatedAt) }}</td>
              <td>{{ formatDate(props.item.createdAt) }}</td>
              <td>
                <v-switch color="primary" v-model="props.item.isActive" @click.stop="switchState(props.item.id)"></v-switch>
              </td>
              <td class="text-center">
                <v-btn fab small icon @click.stop="editItem(props.item)" color="primary">
                  <v-icon small>edit</v-icon>
                </v-btn>
                <v-btn fab small icon @click.stop="deleteItem(props.item)" color="primary">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import NewsEditor from '@/components/News/NewsEditor'
import NewsService from '@/services/news'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
export default {
  components: { NewsEditor },
  mixins: [FilesPathHelpersMixin],
  data: () => ({
    tab: null,
    newsList: [],
    showEditor: false,
    editedIndex: -1,
  }),

  computed: {
    headers () {
      return [
        { sortable: false, width: '50px' },
        { sortable: false, width: '200px' },
        { text: this.$t('News.Form.title'), align: 'left', value: 'title' },
        { text: this.$t('News.Form.author'), value: 'author' },
        { text: this.$t('News.Form.lastUpdate'), value: 'updatedAt' },
        { text: this.$t('News.Form.createdAt'), value: 'createdAt' },
        { text: this.$t('News.Form.active'), value: 'isActive' },
        { sortable: false, value: 'actions', width: '150px' },
      ]
    }
  },

  watch: {
    showEditor (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    async initialize () {
      this.newsList = await NewsService.getAll()
    },

    editItem (item) {
      this.editedIndex = this.newsList.indexOf(item)
      this.showEditor = true
    },

    async deleteItem (item) {
      confirm(this.$t('News.Message.delete')) && await NewsService.delete(item.id)
      // Suppression de l'item dans la liste
      this.initialize()
    },

    close () {
      this.showEditor = false
      setTimeout(() => {
        this.editedIndex = -1
      }, 300);
    },

    async save (newsData) {
      const news = this.editedIndex > -1 ? await NewsService.update(newsData) : await NewsService.create(newsData)
      if (newsData.file) await NewsService.updateImage(news.id, newsData.file)
      // ajout ou mise à jour de l'item dans la liste
      this.initialize()
      this.close()
    },

    async switchState (id) {
      const newsIndex = this.newsList.findIndex(news => news.id === id)
      const updatedNews = await NewsService.update(this.newsList[newsIndex])
      this.newsList.splice(newsIndex, 1, updatedNews)
    },

    formatDate(date) {
      return new Date(date).toLocaleString()
    }
  }
}
</script>
